import { render } from "./AdminTests.vue?vue&type=template&id=060717c6&scoped=true&ts=true"
import script from "./AdminTests.vue?vue&type=script&lang=ts"
export * from "./AdminTests.vue?vue&type=script&lang=ts"

import "./AdminTests.vue?vue&type=style&index=0&id=060717c6&scoped=true&lang=css"
import "./AdminTests.vue?vue&type=style&index=1&id=060717c6&lang=css"
import "./AdminTests.vue?vue&type=style&index=2&id=060717c6&lang=css"
import "./AdminTests.vue?vue&type=style&index=3&id=060717c6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-060717c6"]])

export default __exports__